<template>
  <div
    class="oss-upload-bg"
    @scroll.prevent
  >
    <span
      class="oss-upload-bg_box"
      v-for="item in list"
      :key="item.name"
    >
      <el-progress
        :percentage="item.process"
        :stroke-width="14"
        text-inside
      ></el-progress>
      <p class="oss-upload-bg_box--name">{{item.name}}</p>
    </span>
  </div>
</template>

<script>
export default {
  name: 'UploadProgress',
  data() {
    return {
      list: []
    }
  },
  mounted() {
    if (this.list && this.list.length) {
      this.list = [];
    }
  },
  destroyed() {
    this.list = [];
  },
  methods: {
    receiveProgress(process, name) {
      process = Math.floor(process * 100 * 100) / 100;
      
      let i = this.list.length;
      let item;
      while (i--) {
        item = this.list[i];
        if (item.name === name) {
          item.process = process;
          return;
        }
      }
      this.list.push({
        name, process
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.oss-upload-bg {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 3000;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);

  &_box {
    margin: 10px 0;
    width: 60%;

    &--name {
      font-size: 14px;
      line-height: 2;
      color: #9c99aa;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/untils/upload-progress/upload-progress.vue